/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'files': {
    width: 19,
    height: 16,
    viewBox: '0 0 19 16',
    data: '<path pid="0" d="M6.345 7.433c-.117.03-.165.098-.224.256-.055.077-.075.139-.062.206v3.472c.069.304.069.304.299.458l3.177 1.317.019.007.174-.007.174.007 3.196-1.324c.23-.154.23-.154.299-.458V7.88a.24.24 0 0 0-.047-.15c-.07-.203-.117-.274-.274-.304l-.037-.037-3.12-1.297c-.203-.053-.203-.053-.364-.007L6.37 7.405l-.025.028zm2.277-4.32a.46.46 0 0 0 .439.322h9.454c.245 0 .443.198.443.443v11.078a.443.443 0 0 1-.443.443H.94a.443.443 0 0 1-.442-.443V1.368c0-.245.198-.443.442-.443h6.65c.201 0 .379.13.44.321l.592 1.867zm3.775 5.504v2.417l-2.17.898V9.515l2.17-.898zm-3.17.899v2.416l-2.168-.898V8.617l2.169.899zm2.366-1.648l-1.865.772-1.865-.773 1.868-.773 1.862.774zM8.714 1.29h9.382c.223 0 .403.181.403.404V2.71H9.224l-.51-1.42z" _fill="#BCBCBC" fill-rule="evenodd"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/files.js